import { inject, ref, watch, type Ref } from 'vue'

/**
 * Watches the shared `pendingComposerPrefill` ref provided by
 * {@link ./useVerdictsIntroState.ts} and forwards any non-null prompt into the caller's
 * composer via the provided prefill callback. Resets the signal to `null` after
 * consuming so the same prompt can be re-sent later without re-firing.
 *
 * Lives as a composable so the (identical) wiring does not have to be duplicated across
 * the fullscreen and side-panel composer files.
 *
 * @param prefillFromTemplate - Callback that writes the given content into the composer
 *     textarea and focuses it.
 */
export function useComposerPrefill(prefillFromTemplate: (content: string) => void) {
  const pendingComposerPrefill = inject<Ref<string | null>>(
    'pendingComposerPrefill',
    ref<string | null>(null)
  )

  watch(pendingComposerPrefill, (prompt) => {
    if (prompt === null) return
    prefillFromTemplate(prompt)
    pendingComposerPrefill.value = null
  })
}
